export const AUTH_STORAGE_USER_INFO_KEY = "userInfo";
export const AUTH_STORAGE_ID_TOKEN_KEY = "idToken";

export const storageUtils = {
  setItem: (key, value, expiresAt) => {
    const item = {
      value: value,
      expiresAt: expiresAt,
    };
    localStorage.setItem(key, JSON.stringify(item));
  },

  getItem: (key) => {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    try {
      const item = JSON.parse(itemStr);
      const now = new Date().getTime();

      if (item.expiresAt && now > item.expiresAt) {
        localStorage.removeItem(key);
        return null;
      }

      return item.value;
    } catch (e) {
      console.error("Failed to parse localStorage item:", e);
      localStorage.removeItem(key);
      return null;
    }
  },

  removeItem: (key) => {
    localStorage.removeItem(key);
  },
};
